module.exports = __webpack_public_path__ + "media/images/error-d058469905396338cb5df64d2828ba4e.svg";